import _ from "lodash";
import {ajaxApi, ajaxApiGet, ajaxFromdataPost} from '../../server/index'
import commom from '@/public/common'
const prefix = commom.javaBase_url
/**
 * 查询渠道订单数量
 * @returns 
 */
export async function getOrderCount(params) {
  return new Promise(async (resolve, reject) => {
    const _res =  await ajaxApi(
      `${prefix}brandwx/brandorder/getordercount`,
      // `http://192.168.10.167:9501/brandwx/brandorder/getordercount`,
      { ...params },
       (res) => { reject(res) }
    );
    if (_.get(_res, 'data')) {
      resolve(_.get(_res, 'data', null))
    } else {
      reject(_res)
    }
  })
}
/**
 * 查询最近一次购买渠道
 * @returns 
 */
export async function getLatestChannel(params) {
  return new Promise(async (resolve, reject) => {
    const _res =  await ajaxApi(
      `${prefix}brandwx/brandorder/getlatestchannel`,
      // `http://192.168.10.167:9501/brandwx/brandorder/getlatestchannel`,
      { ...params },
       (res) => { reject(res) }
    );
    if (_.get(_res, 'data')) {
      resolve(_.get(_res, 'data', null))
    } else {
      reject(_res)
    }
  })
}
/**
 * 分页查询品牌订单列表
 * @returns 
 */
export async function getBrandOrder(params) {
  return new Promise(async (resolve, reject) => {
    const _res =  await ajaxApi(
      `${prefix}brandwx/brandorder/getbrandorder`,
      // `http://192.168.10.167:9501/brandwx/brandorder/getbrandorder`,
      { ...params },
       (res) => { reject(res) }
    );
    if (_.get(_res, 'data')) {
      resolve(_.get(_res, 'data.order_list', null))
    } else {
      reject(_res)
    }
  })
}
/**
 * 查询订单商品详情
 * @returns 
 */
export async function getItemList(params) {
  return new Promise(async (resolve, reject) => {
    const _res =  await ajaxApi(
      `${prefix}brandwx/brandorder/getitemlist`,
      // `http://192.168.10.167:9501/brandwx/brandorder/getitemlist1`,
      { ...params },
       (res) => { reject(res) }
    );
    if (_.get(_res, 'data')) {
      resolve(_.get(_res, 'data', null))
    } else {
      reject(_res)
    }
  })
}
/**
 * 商品搜索
 * @returns 
 */
export async function itemSearch(params) {
  return new Promise(async (resolve, reject) => {
    const _res = await ajaxApi(
      `${prefix}brandwx/item/itemsearch`,
      { ...params, source_channel: 'mina', "sort": "default", },
      (res) => { reject(res) }
    );
    if (_.get(_res, 'data')) {
      resolve(_.get(_res, 'data', null))
    } else {
      reject(_res)
    }
  })
}
/**
 * 获取品牌埋点参数
 * @returns 
 */
export async function getUtmCampaign(params) {
  return new Promise(async (resolve, reject) => {
    const _res =  await ajaxApiGet(
      `${prefix}brandwx/brandorder/getUtmCampaign`,
      // `http://192.168.10.167:9501/brandwx/brandorder/getUtmCampaign`,
      { ...params},
       (res) => { reject(res) }
    );
    if (_.get(_res, 'data')) {
      resolve(_.get(_res, 'data', null))
    } else {
      reject(_res)
    }
  })
}


// WEBPACK FOOTER //
// ./src/pages/udeskSide/service.js